import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MainService } from '../../service/main.service';
import { Router } from '@angular/router';
import { ToasterServiceService } from '../../service/toaster.service';
import { LocalStorageService } from '../../service/local-storage.service';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent {

  loginForm: FormGroup;
  submitted = false;
  showPassword: boolean = false;

  constructor(
    private fb: FormBuilder,
    private mainService: MainService,
    private router: Router,
    private toasterService: ToasterServiceService,
    private localStorageService: LocalStorageService
  ) {
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required]],
    });
  }

  get f() {
    return this.loginForm.controls;
  }

  onLogin() {
    this.submitted = true;

    if (this.loginForm.invalid) {
      this.toasterService.toastError("Please fill in the form correctly.");
      return;
    }

    const { email, password } = this.loginForm.value;

    this.mainService.login(email, password).subscribe({
      next: (response) => {
        console.log('API Response:', response);

        if (response.success) {
          const token = response.token || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MSwicm9sZSI6IkFkbWluIiwiaXBBZGRyZXNzIjoiOjoxIiwibG9naW5UeXBlIjoibW9iaWxlIiwiZXhwIjoxNjg3MjQyMDE5LCJpYXQiOjE2ODcyNDAyMTl9.QYhJWRlvBqUGd7dINIoYgQGmx-3Kq1jm-4NOREk79QE'; // Use the provided token as a fallback
          this.localStorageService.setData('userEmail', email);
          this.localStorageService.setToken(token);
          this.router.navigate(['dashboard']);
          this.toasterService.toastSuccess("Login successful");
        } else {
          this.toasterService.toastError(response.message || "Login failed");
        }
      },
      error: (err) => {
        this.toasterService.toastError("Invalid email or password.");
        console.error(err);
      },
    });
  }
  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }
}
